import React, { FC } from 'react';

const NotificationActionWrapper: FC<any> = ({ children }) => {
	return (
		<div className="relative flex h-screen w-screen items-center justify-center">
			{/* Background half (top) */}
			<div
				className="absolute left-0 top-0 h-1/2 w-full bg-cover bg-center"
				style={{ backgroundImage: "url('/desktop-simple-layout-bg.png')" }}
			></div>

			{/* Foreground content */}
			<div
				style={{ width: 600, minHeight: 440 }}
				className="relative z-10 flex flex-col items-center justify-center gap-4 rounded-xl bg-white p-6 text-center shadow-notifications-card"
			>
				{children}
			</div>
		</div>
	);
};

export default NotificationActionWrapper;
